import styled from 'styled-components';

export const StylesBackgroundColours = styled.div.attrs({
  role: 'radiogroup',
})`
  position: relative;
`;
